import React, {useContext, useState, useEffect} from 'react'
import farmerContext from '../../../context/farmer/farmerContext'
import {useAlert} from "react-alert";
import {useParams} from 'react-router-dom';


const EditFarm = (props) => {

    const FarmerContext = useContext(farmerContext);
    const {getFarmType, updateFarm, clearAlert, farmer, getFarms} = FarmerContext;
    const {farmTypes, farms} = farmer;

    const [longitude, setLongitude] = useState('');
    const [latitude, setLatitude] = useState('');
    const alert = useAlert()

    const farm_id = useParams().farm_id
    let [current, setCurrent] = useState([
        {
            farm_name: "",
            address: ""
        }
    ])
    useEffect(() => {
        getLocation();
        if (farmTypes.length === 0) {
            getFarmType();
        }
        if (farms.length === 0) {
            getFarms();
        } else {
            current = farms.filter(farm => {
                return farm.id === parseInt(farm_id);
            })
            setCurrent(current)
        }
        if (farmer.message.msg !== "") {
            alert.show(
                farmer.message.msg, farmer.message.msg_options
            )
            clearAlert()
        }
    }, [farms, farmer.message.msg]);


    const onSubmit = e => {
        e.preventDefault()

        let edit_farm_form = document.getElementById("edit_farm_form");

        let edit_farm = new FormData(edit_farm_form);
        updateFarm(edit_farm, farm_id).then(res => {
            if (res.request.status === 201) {
                props.history.push('/farmer/farm/manage');
            }
        })
    }

    //Get Users location
    const getLocation = () => {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(showPosition);
        } else {
            // alert( "Geolocation is not supported by this browser.");
        }
    }

    //Set the longitude and latitude
    const showPosition = position => {

        let latitude = position.coords.latitude;
        let longitude = position.coords.longitude;

        setLatitude(latitude);
        setLongitude(longitude);

    }


    return (

        <div className="content-wrapper">
            <div className="container-fluid">
                <h3 className="make-bold">Edit Farm</h3>

                <div className="dashboard-inner-view">
                    <div className="row mt-3">
                        <div className="col-lg-5">
                            <form onSubmit={onSubmit} id="edit_farm_form">

                                <div className="form-group mb-5">
                                    <label>Farm Name</label>
                                    <input type="text" className="form-control form-control-custom-view"
                                           name='farm_name' placeholder="Ajayi Farms"
                                           defaultValue={current[0].farm_name}
                                           required/>
                                </div>

                                <div className="form-group mb-5">
                                    <label>Farm Type</label>

                                    <select className="form-control " name="farm_type_id" id="farm_type_id">
                                        <option>--Select farm type--</option>
                                        {farmTypes.length > 0 ?
                                            farmTypes.map(farmType => (
                                                <option value={farmType.id}
                                                        key={farmType.id}>{farmType.name}
                                                </option>
                                            ))

                                            : <option>--Select farm type--</option>

                                        }
                                    </select>

                                </div>

                                <div className="form-group mb-5">
                                    <label>Farm Size</label>
                                    <input type="number" min="1" className="form-control form-control-custom-view"
                                           name='farm_size' placeholder="size in hectares" required/>
                                </div>

                                <div className="form-group">

                                    <input type="hidden" name="latitude" value={latitude && latitude}/>
                                </div>
                                <div className="form-group">
                                    <input type="hidden" name="longitude" value={longitude && longitude}/>
                                </div>

                                <div className="form-group mb-5">
                                    <label>Address</label>
                                    <textarea className="form-control form-control-custom-view" rows="5"
                                              name='address' placeholder="No 3, Hebert Perkins Street, Lekki"
                                              defaultValue={current[0].address}
                                              required>

                                     </textarea>
                                </div>

                                <div className="form-row">
                                    <div className="form-group col-lg-4">
                                        <input type="submit" value="UPDATE FARM" className="btn btn-orange btn-custom-view
                                         text-white btn-block d-flex justify-content-center align-items-center"/>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                {/* <!--End Dashboard Content--> */}
            </div>
            {/* <!-- End container-fluid--> */}
        </div>
        // {/* <!--End content-wrapper--> */}
    )
}

export default EditFarm
